import {
    Divider,
    IconButton,
    InputAdornment,
    Link as MLink,
    List,
    ListItem,
    Paper,
    Stack,
    TextField,
    Box,
    Typography,
    Menu,
    MenuItem,
    Chip,
    Switch,
    FormControlLabel,
} from "@mui/material";
import _ from "lodash";
import Scrollbar from "../scrollbar";
import SearchIcon from "@mui/icons-material/Search";
import HtmlTooltip from "../HtmlTooltip";
import CardTooltipContent from "../../dashboard/card/CardTooltipContent";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useDashboard } from "../../../context/DashboardContext";
import { useCallback, useState } from "react";
import AddCustomTabDialog from "../custom-tab-dialog/AddCustomTabDialog";
import { PAGE_TYPE } from "../../../types/pages.type";
import AddCombineTabDialog from "../custom-tab-dialog/AddCombineTabDialog";
import { CUSTOM_TAB_TYPE } from "../../../types/common.type";
import CustomTabMenu from "./CustomTabMenu";


const FilterCardList = ({
    setSearchText,
    searchText,
    isOpenCloseAll,
    handleAddCustomCard,
    setIsOpenCloseAll,
    scrollHeight,
    listData,
    scrollToSection,
    selectedCards,
    type = null,
    transferType = null,
    pageProp = null,
    hideSearchBar = false,
}) => {
    const { dashboardData: { page, filter } } = useDashboard();

    const [customCard, setCustomCard] = useState(null);
    const [combineCard, setCombineCard] = useState(null);
    const [editEle, setEditEle] = useState(null);
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [showHiddenTabs, setShowHiddenTabs] = useState(false);

    const handleOpenCustomCard = () => {
        setCustomCard(true);
    };

    const handleCloseCustomCard = () => {
        setCustomCard(false);
    };

    const handleEdit = useCallback((ele, { isCreator }) => {
        setEditEle({ ...ele, isCreator });
    }, []);

    const handleMenuOpen = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const handleCombineTabs = () => {
        handleMenuClose();
        setCombineCard(true);
    };

    const handleCloseCombineCard = () => {
        setCombineCard(null);
    };

    return (
        <div>
            {!!editEle && editEle?.type !== CUSTOM_TAB_TYPE.combineTab && <AddCustomTabDialog
                page={page}
                handleClose={() => setEditEle(null)}
                filter={filter}
                id={editEle?._id}
                isCreator={editEle?.isCreator}
                existingTabOptions={listData}
            />}

            {!!customCard && <AddCustomTabDialog
                page={page}
                handleClose={handleCloseCustomCard}
                filter={filter}
                existingTabOptions={listData}
            />}

            {!!combineCard && <AddCombineTabDialog
                page={page}
                handleClose={handleCloseCombineCard}
                filter={filter}
                existingTabOptions={listData}
            />}
            {!!editEle && editEle?.type === CUSTOM_TAB_TYPE.combineTab && <AddCombineTabDialog
                page={page}
                handleClose={() => setEditEle(null)}
                filter={filter}
                id={editEle?._id}
                isCreator={editEle?.isCreator}
                existingTabOptions={listData}
            />}
            <Paper
                sx={{
                    borderRadius: "0px 0px 8px 8px",
                    boxShadow: 3,
                    ...type !== "scroll" ? { margin: "0px 4px 4px 4px" } : {}
                }}
            >
                {!hideSearchBar && (
                    <TextField
                        fullWidth
                        sx={{ px: 1.5, p: 1.5 }}
                        placeholder="Search tab"
                        size="small"
                        onChange={(e) => setSearchText(e.target.value)}
                        value={searchText}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                )}
                {/* Display hidden tabs toggle - only show if there are shared tabs */}
                {listData.some(tab => tab.isShared) && (
                    <Box sx={{ px: 1.5, py: 0.5 }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    size="small"
                                    checked={showHiddenTabs}
                                    onChange={(e) => setShowHiddenTabs(e.target.checked)}
                                    sx={{
                                        '& .MuiSwitch-switchBase.Mui-checked': {
                                            color: '#2196f3',
                                        },
                                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                            backgroundColor: '#2196f3',
                                        },
                                    }}
                                />
                            }
                            label={
                                <Typography variant="caption" sx={{ fontSize: '11px', color: '#666' }}>
                                    Display hidden tabs
                                </Typography>
                            }
                        />
                    </Box>
                )}

                <Box display="flex" justifyContent="flex-end" alignItems="center" sx={{ px: 1, py: 0.2 }}>
                    {/* Show menu for all page types */}
                    <>
                        <MLink
                            sx={{
                                px: 1.5,
                                opacity: 1,
                                cursor: 'pointer',
                            }}
                            component="button"
                            variant="body2"
                            onClick={handleMenuOpen}
                        >
                            Create Custom Tabs
                        </MLink>
                        <Menu
                            anchorEl={menuAnchorEl}
                            open={Boolean(menuAnchorEl)}
                            onClose={handleMenuClose}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        >
                            {page !== PAGE_TYPE.OVERALL ? (
                                <MenuItem onClick={() => { handleMenuClose(); handleOpenCustomCard(); }}>
                                    Create resident data flow tab
                                </MenuItem>
                            ) : null}
                            <MenuItem onClick={handleCombineTabs}>
                                Combine Data From Separate Dashboard tabs
                            </MenuItem>
                        </Menu>
                    </>
                </Box>
                <Divider />
                <Scrollbar
                    sx={{
                        height: scrollHeight ? scrollHeight : 200,
                        width: "100%",
                        '@media (max-width:1280px)': {
                            height: '160px'
                        },
                        '@media (min-width:1480px)': {
                            height: '303px'
                        },
                    }}
                    rootSx={{
                        borderRadius: "8px 8px 8px 8px",
                    }}
                >
                    <List
                        sx={{
                            bgColor: "background.paper",
                            px: 2,
                            py: 2,
                        }}
                        dense
                    >
                        {_.orderBy(listData, "label", "ASC")
                            .filter((ele) => {
                                // Filter by search text
                                const searchString = (searchText || "").trim().toLowerCase();
                                const matchesSearch = (ele.label || "").toLowerCase().includes(searchString);

                                // Filter by hidden status
                                if (showHiddenTabs) {
                                    // Show only hidden shared tabs
                                    return matchesSearch && ele.isShared && ele.isHidden;
                                } else {
                                    // Show non-hidden tabs (default behavior)
                                    return matchesSearch && (!ele.isShared || !ele.isHidden);
                                }
                            })
                            .map((ele, index) => {
                                const isSelected = _.includes(selectedCards, ele.value) || ele.isDefaultCard;
                                return (
                                    <ListItem
                                        onClick={ele?.isHidden ? undefined : (isSelected ? async () => {
                                            // Redirect to selected card (may expand collapsed category first)
                                            if (ele.isDefaultCard && !_.includes(selectedCards, ele.value)) {
                                                await handleAddCustomCard(ele.value);
                                            }
                                            void scrollToSection(ele.value);
                                        } : async () => {
                                            // Add card first and wait for it to complete
                                            await handleAddCustomCard(ele.value);
                                            // Wait for React to render the new card in DOM
                                            // Use requestAnimationFrame to wait for next paint cycle
                                            requestAnimationFrame(() => {
                                                requestAnimationFrame(() => {
                                                    // Check if element exists and scroll
                                                    let retryCount = 0;
                                                    const maxRetries = 10;
                                                    const checkAndScroll = () => {
                                                        const id = `${ele.value}_scroll`;
                                                        const element = document.getElementById(id);
                                                        if (element) {
                                                            void scrollToSection(ele.value);
                                                        } else if (retryCount < maxRetries) {
                                                            retryCount++;
                                                            requestAnimationFrame(checkAndScroll);
                                                        }
                                                    };
                                                    checkAndScroll();
                                                });
                                            });
                                        })}
                                        key={ele.value}
                                        dense
                                        disableGutters
                                        sx={{
                                            cursor: ele?.isHidden ? 'default' : 'pointer',
                                            borderRadius: '10px',
                                            background: isSelected ? '#f0f7ff' : '#ffffff',
                                            border: isSelected ? '1px solid #4a6cf7' : '1px solid #f1f5f9',
                                            boxShadow: isSelected 
                                                ? '0 4px 12px rgba(74, 108, 247, 0.08)' 
                                                : '0 1px 2px rgba(0, 0, 0, 0.02)',
                                            marginBottom: '9px',
                                            px: 0,
                                            py: 0,
                                            overflow: 'hidden',
                                            position: 'relative',
                                            opacity: ele?.isHidden ? 0.6 : 1,
                                            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                            '&:hover': {
                                                transform: ele?.isHidden ? 'none' : 'translateX(4px)',
                                                background: isSelected ? '#f0f7ff' : '#f8faff',
                                                borderColor: '#4a6cf7',
                                                boxShadow: '0 6px 16px rgba(0, 0, 0, 0.06)',
                                            },
                                            // Selection indicator bar
                                            '&::before': {
                                                content: '""',
                                                position: 'absolute',
                                                left: 0,
                                                top: 0,
                                                bottom: 0,
                                                width: isSelected ? '3px' : '0px',
                                                background: '#4a6cf7',
                                                transition: 'all 0.2s ease',
                                            }
                                        }}
                                    >
                                        <Box sx={{ 
                                            display: 'flex', 
                                            width: '100%', 
                                            alignItems: 'center',
                                            px: 1.5,
                                            py: 1,
                                        }}>
                                            {/* Left Side: Tooltip + Label */}
                                            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <HtmlTooltip
                                                        content={<CardTooltipContent content={ele?.tooltipContent} />}
                                                    >
                                                        <IconButton
                                                            disableFocusRipple
                                                            disableRipple
                                                            sx={{ 
                                                                cursor: 'pointer',
                                                                p: 0.5,
                                                                mr: 0.5,
                                                                background: isSelected ? 'rgba(74, 108, 247, 0.05)' : 'rgba(0,0,0,0.02)',
                                                                '&:hover': { background: 'rgba(74, 108, 247, 0.1)' }
                                                            }}
                                                            size="small"
                                                        >
                                                            <InfoOutlinedIcon sx={{ fontSize: '16px', color: isSelected ? '#4a6cf7' : '#94a3b8' }} />
                                                        </IconButton>
                                                    </HtmlTooltip>
                                                </div>
                                                <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                    <Typography
                                                        sx={{
                                                            ml: 0.5,
                                                            whiteSpace: 'normal',
                                                            wordBreak: 'break-word',
                                                            fontFamily: 'manrope',
                                                            fontWeight: isSelected ? 700 : 600,
                                                            letterSpacing: '0.01em',
                                                            textTransform: 'none',
                                                            fontSize: '12.5px',
                                                            color: isSelected ? '#2563eb' : '#475569',
                                                            lineHeight: 1.4,
                                                            transition: 'all 0.2s ease',
                                                        }}
                                                    >
                                                        {ele.label}
                                                    </Typography>
                                                    {ele?.isShared && (
                                                        <Chip
                                                            label={ele?.isHidden ? "hidden" : "shared"}
                                                            size="small"
                                                            variant="outlined"
                                                            color={ele?.isHidden ? "warning" : "success"}
                                                            sx={{
                                                                height: '14px',
                                                                fontSize: '9px',
                                                                fontWeight: 'bold',
                                                                ml: -2.0,
                                                                mb: 2.8,
                                                                '& .MuiChip-label': {
                                                                    padding: '0 3px',
                                                                    marginTop: "1.5px",
                                                                    fontSize: '9px',
                                                                    fontWeight: 'bold',
                                                                    textTransform: 'lowercase'
                                                                }
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            </Box>

                                            {/* Right Side: Actions */}
                                            <Stack direction="row" spacing={0.2} alignItems="center" sx={{ ml: 0.5, flexShrink: 0 }}>
                                                {ele?.isCustomTab && ele?._id && (
                                                    <CustomTabMenu
                                                        ele={ele}
                                                        onEdit={handleEdit}
                                                        handleAddCustomCard={handleAddCustomCard}
                                                        selectedCards={selectedCards}
                                                        isSelected={isSelected}
                                                    />
                                                )}
                                            </Stack>
                                        </Box>
                                    </ListItem>
                                )
                            })}
                    </List>
                </Scrollbar>
            </Paper>
        </div>
    );
};

export default FilterCardList;